import * as yup from 'yup';

export type PaymentInvoiceType = yup.InferType<typeof paymentInvoiceSchema>;

export const paymentInvoiceSchema = yup.object().shape({
  payment_invoice_id: yup.number().label('Payment Invoice').optional(),
  approve_status: yup.number().optional().nullable(),
  approve_by_name: yup.string().optional().nullable(),
  invoice_id: yup.number().label('Invoice').optional(),
  coa_id: yup
    .number()
    .label('Payment Account')
    .typeError('Payment Account is required')
    .required(),
  coa_name: yup.string().label('Code').optional(),
  coa_balance: yup.number().label('Balanace'),
  customer_id: yup
    .number()
    .label('Customer')
    .typeError('Customer is required')
    .required(),
  customer_name: yup.string().label('Customer').optional(),
  deposit_amount: yup
    .number()
    .label('Deposit Amount')
    .typeError('Deposit Amount is required')
    .required()
    .min(0, "Deposit amount cannot be negative")
    .test(
      "max-total-deposit",
      "Deposit amount cannot be larger than Total Deposit",
      function (value) {
        const total_deposit = Number(this.parent.total_deposit ?? 0);
        return value <= total_deposit;
      }
    ),
  payment_amount: yup
    .number()
    .label('Payment Amount')
    .min(0, "Payment amount cannot be negative")
    .typeError('Payment Amount is required')
    .required(),
  balance_invoice: yup.number().label('Balance').defined(),
  balance: yup
    .number()
    .label('Balance')
    .defined()
    .test('shouldNotBeMinus', 'Balance cannot be minus', (value) => value >= 0),
  location_id: yup
    .number()
    .label('Location')
    .typeError('Location is required')
    .required(),
  link: yup.string().label('Link').required(),
  shipped: yup.string().label('Shipped').required(),
  memo: yup.string().label('Memo').required(),
  referensi: yup.string().label('No Cheque').required(),
  trx_code: yup.string().label('Code').optional(),
  transaction_date: yup.string().label('Transaction Date').required(),
  imgPath: yup.array().of(yup.object().shape({
    file_path: yup.string().required(),
  })).label("FILE").min(0).optional(),
  total_deposit: yup.number()
});
